module.exports = __webpack_public_path__ + "static/media/phone-wifi.03544512.svg";